import { render } from "./LiveData.vue?vue&type=template&id=604c90e3"
import script from "./LiveData.vue?vue&type=script&lang=js"
export * from "./LiveData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__